import css from 'styled-jsx/css'
import ProductItemLoading from '../product-item/ProductItemLoading'
export default function CatalogLoading() {
  return (
    <>
      <div className="banner-collection">
        <div className="banner-collection__header skeleton"></div>
        <div className="banner-collection__text--1 skeleton"> </div>
        <div className="banner-collection__text--2 mt-1 skeleton"> </div>
      </div>

      <div className="has-bg-white">
        <div className="ministore-catalog container-beva">
          <style jsx global>
            {globalStyle}
          </style>
          <div className="columns">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
              <div
                key={`${index}-product-loading`}
                className="column is-12-mobile is-4-tablet is-3-desktop"
              >
                <ProductItemLoading />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

const globalStyle = css.global`
  .banner-collection {
    padding: 32px 24px;

    display: flex;
    flex-direction: column;
    align-items: center;

    &__header {
      height: 36px;
      width: 160px;
      margin-bottom: 8px;
    }

    &__text {
      &--1 {
        height: 22px;
        max-width: 930px;
        width: 100%;
      }
      &--2 {
        height: 22px;
        max-width: 560px;
        width: 60%;
      }
    }
  }
  .ministore-catalog {
    padding-top: 24px;
    padding-bottom: 72px;
    .columns {
      flex-wrap: wrap;
      grid-row-gap: 48px;
      margin-top: 0px;
      margin-bottom: 0px;
      .column {
        padding: 0 12px;

        &:last-child {
          .info {
            border-bottom: none;
          }
        }
      }
    }
  }
  @media screen and (min-width: 768px) {
    .banner-collection {
      padding-left: 32px;
      padding-right: 32px;
      &__header {
        height: 48px;
      }

      &__text {
        &--1 {
          height: 28px;
        }
        &--2 {
          height: 28px;
        }
      }
    }
    .ministore-catalog {
      padding-top: 50px;
      padding-bottom: 102px;
    }
  }

  @media screen and (min-width: 1024px) {
    .ministore-catalog {
      .columns {
        grid-row-gap: 72px;
      }
    }
    .banner-collection {
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  .skeleton {
    background-color: #a5a5a5;
    animation: skeleton-animation 1.5s infinite ease-in-out;
  }

  @keyframes skeleton-animation {
    0% {
      opacity: 0.2;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 0.2;
    }
  }
`
